export default __webpack_public_path__ + "static/media/RC_Invite_Dep_Guide.4159c6ba.docx";